import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";

function ViewPdfModal({ openPDFModal, setOpenPDFModal, pdfUrl }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);

  useEffect(() => {
      const handleContextMenu = (e) => {
      e.preventDefault()
      }
      document.addEventListener("contextmenu", handleContextMenu)
      return () => {
      document.removeEventListener("contextmenu", handleContextMenu)
      }
  }, [])

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToNextPage = () => {
    setPageNumber((prevPageNumber) => Math.min(prevPageNumber + 1, numPages));
  };

  const goToPreviousPage = () => {
    setPageNumber((prevPageNumber) => Math.max(prevPageNumber - 1, 1));
  };

  const zoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.2, 3));
  };

  const zoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5));
  };

  return (
    <Modal
      width={"80%"}
      title="View Document"
      open={openPDFModal}
      className="claim-status-modal"
      onCancel={() => setOpenPDFModal(false)}
      onOk={() => setOpenPDFModal(false)}
      footer={null}
      bodyStyle={{
        padding: 0,
        height: "90vh",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <div
        style={{
          padding: "10px 20px",
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #ddd",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Pagination Controls */}
        <div>
          <button
            onClick={goToPreviousPage}
            disabled={pageNumber <= 1}
            style={{
              padding: "5px 10px",
              borderRadius: "4px",
              backgroundColor: pageNumber > 1 ? "#1890ff" : "#ccc",
              color: "white",
              border: "none",
              cursor: pageNumber > 1 ? "pointer" : "not-allowed",
              marginRight: "10px",
            }}
          >
            Previous
          </button>
          <button
            onClick={goToNextPage}
            disabled={pageNumber >= numPages}
            style={{
              padding: "5px 10px",
              borderRadius: "4px",
              backgroundColor: pageNumber < numPages ? "#1890ff" : "#ccc",
              color: "white",
              border: "none",
              cursor: pageNumber < numPages ? "pointer" : "not-allowed",
            }}
          >
            Next
          </button>
        </div>

        {/* Current Page Info */}
        <span style={{ fontWeight: "bold" }}>
          Page {pageNumber} of {numPages}
        </span>

        {/* Zoom Controls */}
        <div>
          <button
            onClick={zoomOut}
            disabled={scale <= 0.5}
            style={{
              padding: "10px",
              borderRadius: "4px",
              backgroundColor: scale > 0.5 ? "#1890ff" : "#ccc",
              color: "white",
              border: "none",
              cursor: scale > 0.5 ? "pointer" : "not-allowed",
              marginRight: "10px",
            }}
          >
            <span>Zoom Out</span>
          </button>
          <button
            onClick={zoomIn}
            disabled={scale >= 3}
            style={{
              padding: "10px",
              borderRadius: "4px",
              backgroundColor: scale < 3 ? "#1890ff" : "#ccc",
              color: "white",
              border: "none",
              cursor: scale < 3 ? "pointer" : "not-allowed",
            }}
          >
            <span>Zoom In</span>
          </button>
        </div>
      </div>

      {/* PDF Content */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          textAlign: "center",
          margin: "auto",
          maxWidth: "100%",
        }}
      >
        <Document file={pdfUrl} onLoadSuccess={onLoadSuccess}>
          <Page pageNumber={pageNumber} scale={scale} />
        </Document>
      </div>
    </Modal>
  );
}

export default ViewPdfModal;
